// extracted by mini-css-extract-plugin
export default {"heading":"ProfileUploadPhoto_heading__Orhzq","imagesRow":"ProfileUploadPhoto_imagesRow__M-C69","ImgDiv":"ProfileUploadPhoto_ImgDiv__skoG8","Img":"ProfileUploadPhoto_Img__lMR9g"};